<button
  (click)="onClick($event)"
  [disabled]="disabled"
  class="dropdown-menu-item"
  [ngClass]="class"
  mat-menu-item
>
  <ng-content></ng-content>
</button>
